import React from 'react';
import UserSection from '../UserSection';
import * as S from './styles';
const CustomerMenuContainer = ({ customer }) => {
    if (typeof customer === 'undefined') {
        return null;
    }
    const { displayName, fullName, accountIds } = customer;
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.InfoSection, null,
            React.createElement(UserSection, { displayName: displayName, fullName: fullName, accountIds: accountIds }))));
};
export default CustomerMenuContainer;
//# sourceMappingURL=index.js.map